import { getName, getHrefCC } from '../helpers/helpers';
import type { ICookieInit } from '../models';
import { showDraft, showForm } from '../config';

import { BaseCookie } from './base';

// TODO: вынести в командную папку
export class CCCookie extends BaseCookie {
    constructor({ cookieName = 'continue-draft', products = [], setState }: ICookieInit) {
        super({ cookieName, products, setState });
        setState(showForm);
    }

    removeCookie() {
        super.removeCookie();
        this.setState(state => ({
            ...state,
            ...showForm,
        }));
    }

    parseCookie() {
        if (!this.parsedCookie) return;

        const { cardType, draftId, personFirstName, personMiddleName } = this.parsedCookie;

        const hasName = personFirstName && personMiddleName;
        const product = this.currentProducts.find(val => val === cardType)
            ? cardType
            : this.currentProducts[0];

        this.setState({
            href: getHrefCC(draftId, product),
            text: hasName ? getName(personFirstName, personMiddleName) : '',
            onRemove: () => this.removeCookie(),
            ...showDraft,
        });
    }
}
